import { useCallback, useEffect, useState } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const useModalScroll = (contentRef: React.MutableRefObject<HTMLDivElement | null>, open: boolean) => {
    const [scrollX, setScrollX] = useState(0);
    const [scrollY, setScrollY] = useState(0);

    const cleanUpDisabledBodyScroll = useCallback((target: HTMLDivElement | null) => {
        if (target) enableBodyScroll(target);
    }, []);

    const restoreScrollPosition = useCallback(() => {
        window.scrollTo(scrollX, scrollY);
    }, [scrollX, scrollY]);

    const saveScrollPosition = useCallback(
        (positionX: number, positionY: number) => {
            setScrollX(positionX);
            setScrollY(positionY);
        },
        [setScrollX, setScrollY]
    );

    useEffect(() => {
        const target = contentRef.current;
        if (open) {
            saveScrollPosition(window.scrollX, window.scrollY);
            if (target) disableBodyScroll(target);
        }
        return () => {
            cleanUpDisabledBodyScroll(target);
        };
    }, [saveScrollPosition, contentRef, open, cleanUpDisabledBodyScroll]);

    return { restoreScrollPosition, cleanUpDisabledBodyScroll };
};

export default useModalScroll;
